import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import './PLPFilters.scss';

import PLPFiltersModal from './PLPFiltersModal/PLPFiltersModal';
// import OdFilterLinesIcon from '../../../../static/assets/svg/od-filter-lines-icon-desktop.svg';
import OdFilterLinesIconWhite from '../../../../static/assets/svg/od-filter-lines-icon-desktop-white.svg';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as categoryActions from '../../../actionCreators/category';
import { readQueryParam } from '../../../utils/helper';
import { filterHelper } from './PLPFilters.helper';
import ButtonOwnDays from '../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';

const FilterDtm = {
  updateFilterDtm: (filterName, filterType) => {
    let parentKeyToUpdateDtm = filterName;
    if (parentKeyToUpdateDtm?.indexOf('_id') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace(/_/g, '').replace('id', '');
    } else if (parentKeyToUpdateDtm?.indexOf('lenskart') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace('lenskart_', '');
    } else if (parentKeyToUpdateDtm?.indexOf('price') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.concat('range');
    }
    if (filterType) window.dtm.filterType = 'clear all';

    window.dtm[parentKeyToUpdateDtm] = 'clear';
  },
  updateCategoryDtm: (categoryData, dtmArg) => {
    let subC = '';
    const { userInfo, login, sort, filter } = dtmArg;
    const bCrumbArr =
      categoryData.breadcrumb && categoryData.breadcrumb.length ? categoryData.breadcrumb : [];
    const categoryType = categoryData.categoryType ? categoryData.categoryType.toLowerCase() : '';
    bCrumbArr.forEach(data => {
      if (data) {
        subC += `${data.label}-`;
      }
    });
    if (window.dtm !== undefined) {
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.allPage('listing page');
        window.dtm.LenskartRewamp.Listing.load.listing(
          categoryType,
          subC ? subC.slice(0, -1) : categoryType,
          filter,
          sort.toLowerCase(),
          login,
          login ? userInfo.result.id : '',
          dtmArg.obj
        );
      }
    }
  },
};

const PLPFilters = props => {
  const {
    categoryActions,
    filterArray,
    addingGaDataInFilterArray,
    FilterDataObj,
    location,
    categoryId,
  } = props;

  const [isActive, setIsActive] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);

  const handleClose = () => setIsActive(false);

  const loadCatData = data => {
    let mystring = '';
    const incLimit = Object.keys(data).length - 1;
    Object.keys(data).forEach((key, parentIndex) => {
      let mystring2 = '';
      mystring += key;
      data[key].forEach((val, index) => {
        if (index === data[key].length - 1) {
          mystring2 += val.childid;
        } else {
          mystring2 = `${mystring2 + val.childid},`;
        }
      });
      if (parentIndex === incLimit) {
        mystring = `${mystring}=${mystring2}`;
      } else {
        mystring = `${mystring}=${mystring2}&`;
      }
    });
    let loc = '';
    if (location.hash.includes('dir')) {
      if (location.hash.split('dir')[0].length > 0 && location.hash.split('dir')[0].length !== 1) {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir') - 1,
          location.hash.lastIndexOf('true') + 4
        );
      } else {
        loc = location.hash.slice(
          location.hash.lastIndexOf('dir'),
          location.hash.lastIndexOf('true') + 4
        );
      }
    }

    let searchQuery = '';
    if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
      const queryParam = readQueryParam('q', location.search, true);
      searchQuery = `?q=${queryParam}`;
    }

    history.replaceState(
      `${location.pathname}${window.location.hash}`,
      null,
      location.pathname + `${searchQuery}${window.location.hash}`
    );

    categoryActions.loadCatAndFilterData(categoryId, mystring + loc, 0);
  };

  const handleFilter = (name, array, TempData, apiTempData = {}) => {
    filterHelper(name, FilterDataObj, TempData, apiTempData, array, categoryActions, loadCatData);
  };

  const modifySelectedFilterList = (childname, childid, currentFilterData) => {
    const childData = FilterDataObj[currentFilterData.id] || [];
    const index = childData.findIndex(
      item => JSON.stringify(item) === JSON.stringify({ childid, childname })
    );

    if (index > -1) {
      childData.splice(index, 1);
    } else {
      childData.push({ childid, childname });
    }

    const itemIndex = selectedFilter?.indexOf(childname);

    if (itemIndex > -1) {
      setSelectedFilter([...selectedFilter].splice(itemIndex, 1));
    } else {
      setSelectedFilter([...selectedFilter, childname]);
    }

    const filter = {
      [currentFilterData?.id]: childname,
    };
    const allFilter = [filter];

    let isContainFilterData = false;

    if (filterArray.length > 0) {
      isContainFilterData = filterArray.some(item => item[currentFilterData?.id] === childname);
    }

    if (allFilter.length > 0 && !isContainFilterData) {
      const totalFilter = allFilter.length;
      const appliedFilterString = Object.assign({}, ...allFilter);

      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Listing.filter.appliedFilter(appliedFilterString, totalFilter);
    }

    addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname);

    // Update DTM value when filter removed
    if (childData.length === 0) FilterDtm.updateFilterDtm(currentFilterData.id);

    handleFilter(currentFilterData.id, childData);
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsActive(false);
    }
  }, []);

  return (
    <div>
      <ButtonOwnDays
        fontClass="od-font-bold"
        fontSize="18px"
        mode="oval-grey"
        px="20px"
        py="8px"
        style={{ gap: '16px' }}
        onClick={() => setIsActive(true)}
      >
        All Filters
        <div className="plp-filters__content">
          <div
            className={`plp-filters__counter od-font-bold ${
              !filterArray.length && 'plp-filters__counter--empty'
            }`}
          >
            {filterArray.length}
          </div>
          <img alt="Filters" className="plp-filters__icon" src={OdFilterLinesIconWhite} />
        </div>
      </ButtonOwnDays>

      {isActive &&
        ReactDOM.createPortal(
          <PLPFiltersModal
            handleClose={handleClose}
            modifySelectedFilterList={modifySelectedFilterList}
          />,
          document.getElementById('categoryPage')
        )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    FilterDataObj: state.category.FilterDataObj,
    location: state.router.location,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PLPFilters);
